//
// Global init of core components
//

import KTApp from '@/assets/js/components/app.js';

// Init components
var KTComponents = function () {
    // Public methods
    return {
        init: function () {
            KTApp.init();
			KTDrawer.init();
			KTMenu.init();
			KTScroll.init();
			KTSticky.init();
			KTSwapper.init();
			KTToggle.init();
			KTScrolltop.init();
			KTDialer.init();	
			KTImageInput.init();
			KTPasswordMeter.init();	
        }
    }	
}();

// On document ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", function() {
		// KTComponents.init();
		KTApp.init();
	});
 } else {
	// KTComponents.init();
	KTApp.init();
 }

// Init page loader
window.addEventListener("load", function() {
    KTApp.hidePageLoading();
});

export default KTComponents
